
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...stencil]",
      function () {
        return require("private-next-pages/[...stencil].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[...stencil]"])
      });
    }
  